import ApiERP from '@/core/conectores/ApiERP';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IParametrosRelatorioPCP } from '@/models/ParametrosRequisicao/PCP/IParametrosRelatorioPCP';
import { IDTORelatorioPCP } from '@/models/Relatorios/PCP/IDTORelatorioPCP';

/**
 * Serviço de Relatórios de Vendas.
 */

class ServicoRelatorioPCP {
    endPoint = 'relatorios-pcp';

    apiERP = new ApiERP();

    public requisicaoSistema():void{
      this.apiERP = new ApiERP(true);
    }

    public async obterRelatorioPCP(parametros: IParametrosRelatorioPCP): Promise<IDTORelatorioPCP> {
      const result: any = await this.apiERP.post(`${this.endPoint}/painel-pcp`, parametros);
      return result.data;
    }

    public async obterArquivRelatorioPCP(tipoArquivo: ETipoArquivo, parametros: IParametrosRelatorioPCP):Promise<IRetornoRelatorio> {
      const result: any = await this.apiERP.post(`${this.endPoint}/painel-pcp/arquivo/${tipoArquivo}`, parametros);
      return result.data;
    }
}
export default ServicoRelatorioPCP;
